import { useApp, useResponsive, useT } from "@/Hooks";
import LandingAppointmentBookingPage, {
  LandingAppointmentBookingPageProps,
} from "./Booking/LandingAppointmentBookingPage";
import LandingAppointmentReservationConfirmationPage, {
  LandingAppointmentReservationConfirmationPageProps,
  LandingAppointmentReservationConfirmationPageResult,
} from "./ReservationConfirmation/LandingAppointmentReservationConfirmationPage";
import LandingAppointmentSetCenterUserPage, {
  LandingAppointmentSetCenterUserPageProps,
} from "./SetCenterUser/LandingAppointmentSetCenterUserPage";

function useLandingAppointmentModal() {
  const t = useT();
  const { modal } = useApp();
  const { isMobile } = useResponsive();
  const showBooking = (
    props?: Omit<LandingAppointmentBookingPageProps, "callback">,
  ) => {
    return new Promise<boolean>((resolve) => {
      const m = modal.info({
        icon: null,
        title: t(
          "landing.profile.action.bookAppointment",
          undefined,
          "Appointment",
        ),
        footer: [],
        closable: true,
        centered: true,
        width: isMobile ? "100vw" : "45vw",
        onCancel: () => resolve(false),
        content: (
          <LandingAppointmentBookingPage
            {...props}
            callback={(r) => {
              resolve(r);
              m.destroy();
            }}
          />
        ),
      });
    });
  };
  const showReservationConfirmation = (
    props: Omit<LandingAppointmentReservationConfirmationPageProps, "callback">,
  ) => {
    return new Promise<LandingAppointmentReservationConfirmationPageResult>(
      (resolve) => {
        const m = modal.info({
          title: t(
            "landing.appointment.useAppointmentModal.confirmReservation",
            undefined,
            "Appointment",
          ),
          centered: true,
          icon: null,
          closable: true,
          footer: [],
          width: 500,
          // width: isMobile ? '100vw' : '45vw',
          onCancel: () => resolve({ Confirmed: false, ForMyself: false }),
          content: (
            <LandingAppointmentReservationConfirmationPage
              {...props}
              callback={(r) => {
                resolve(r);
                m.destroy();
              }}
            />
          ),
        });
      },
    );
  };
  const showSetCenterUser = (
    props: Omit<LandingAppointmentSetCenterUserPageProps, "callback">,
  ) => {
    return new Promise<boolean>((resolve) => {
      const m = modal.info({
        title: t(
          "landing.appointment.useAppointmentModal.selectClient",
          undefined,
          "Appointment",
        ),
        centered: true,
        icon: null,
        closable: true,
        footer: [],
        width: 500,
        // width: isMobile ? '100vw' : '45vw',
        onCancel: () => resolve(false),
        content: (
          <LandingAppointmentSetCenterUserPage
            {...props}
            callback={(r) => {
              resolve(r);
              m.destroy();
            }}
          />
        ),
      });
    });
  };
  return {
    showBooking,
    showReservationConfirmation,
    showSetCenterUser,
  };
}
export default useLandingAppointmentModal;
